import type { EditorState } from '../types';
import {
  captureClipboardGraph,
  pasteClipboardGraph,
} from '@waka/compat/clipboard-graph';
import { editableTree } from '@waka/compat/group-split';

export const duplicateItems = (
  state: EditorState,
  itemIds: string[],
): EditorState => {
  const ids = itemIds.filter((id) => editableTree(state, id));
  const graph = captureClipboardGraph(state, ids, false);
  if (!graph) return state;
  const from = Math.min(...graph.roots.map((id) => graph.items[id]!.from));
  return pasteClipboardGraph(state, graph, from, null, true);
};
